/* @flow */

import { createSelector } from '@reduxjs/toolkit';

/*
|------------------------------------------------------------------------------
| INPUTS
|------------------------------------------------------------------------------
*/

const _segment = (state) => state.app.support.loginLink;

const _getLoginLinkRequest = (state) => _segment(state).isFetching;
const _getLoginLinkFailure = (state) => _segment(state).failure;
const _getLoginLinkSuccess = (state) => _segment(state).success;
const _getLoginLinkUsername = (state) => _segment(state).username;
const _isLoginLinkResent = (state) => _segment(state).isLoginLinkResent;
const _getLoginLinkEncryptedEmail = (state) =>
  _segment(state).showEncryptedEmail;
const _getLoginLinkResendActive = (state) => _segment(state).resendEmailActive;

/*
|------------------------------------------------------------------------------
| SELECTORS
|------------------------------------------------------------------------------
*/

export const getLoginLinkRequest: (state: Object) => boolean = createSelector(
  [_getLoginLinkRequest],
  (x: boolean): boolean => x,
);

export const getLoginLinkFailure: (state: Object) => Error = createSelector(
  [_getLoginLinkFailure],
  (x: Error): Error => x,
);

export const getLoginLinkUsername: (state: Object) => string = createSelector(
  [_getLoginLinkUsername],
  (x: string): string => x,
);

export const isLoginLinkSent: (state: Object) => boolean = createSelector(
  [_getLoginLinkSuccess],
  (x: boolean): boolean => x,
);
export const isLoginLinkResent: (state: Object) => boolean = createSelector(
  [_isLoginLinkResent],
  (x: boolean): boolean => x,
);

export const getLoginLinkEncryptedEmail: (
  state: Object,
) => string = createSelector(
  [_getLoginLinkEncryptedEmail],
  (x: string): string => x,
);

export const getLoginLinkResendActive: (state: Object) => any = createSelector(
  [_getLoginLinkResendActive],
  (x: any): any => x,
);
